import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-j-small', 'LetterJSmall', [["path",{"d":"M10 8h4v6a2 2 0 1 1 -4 0"}]]);